import { getInitialPreviousCorrectiveImagesParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialPreviousCorrectiveImages/getInitialPreviousCorrectiveImagesQuery.type';
import { getInitialVisitPreviousCorrectiveImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialPreviousCorrectiveImages/getInitialPreviousCorrectiveImagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getInitialPreviousCorrectiveImagesQueryOptions = (
  params: getInitialPreviousCorrectiveImagesParamsType,
) => {
  return queryOptions({
    queryKey: ['getInitialPreviousCorrectiveImagesParamsType', params],
    queryFn: () => getInitialVisitPreviousCorrectiveImagesFunction(params),
  });
};
